import { useState } from 'react';

import { SaleChannelType } from '@anyx/common-graphql';
import { useStoresChannels } from '@anyx/feature-marketplace';
import { useDeepComparisonEffect } from '@anyx/shared-utils';

export const useProductChannels = ({
  storeId,
  accountId,
}: {
  storeId: string;
  accountId?: string;
}) => {
  const { getStoresChannelsTypes, loading } = useStoresChannels();
  const [channels, setChannels] = useState<SaleChannelType[]>([]);

  useDeepComparisonEffect(async () => {
    setChannels(
      await getStoresChannelsTypes({
        storeIds: storeId ? [storeId] : [],
        accountIds: accountId ? [accountId] : [],
      })
    );
  }, [storeId, accountId]);

  return {
    channels,
    loading,
  };
};
